import { useShareActions } from '#src/app/pages/psf/promoteOrShare/shared/hooks';

import { splitShareButtonConfigsByCopy } from '../../utils/splitShareButtonConfigsByCopy';
import { ShareSectionHeading } from '../ShareSectionHeading';

import { InlineShareChannelsCarousel } from './components/InlineShareChannelsCarousel';
import { InlineShareCopyCard } from './components/InlineShareCopyCard';

export const InlineShareCarouselActions: React.FC<EmptyProps> = () => {
	const {
		data: { buttonConfigs },
	} = useShareActions();

	if (buttonConfigs.length === 0) return null;

	const { copyConfig, socialConfigs } = splitShareButtonConfigsByCopy(buttonConfigs);

	if (!copyConfig) return null;

	return (
		<div className="mb-3 flex flex-col gap-6">
			<ShareSectionHeading />
			<div className="flex flex-col">
				<InlineShareCopyCard buttonConfig={copyConfig} />
				{socialConfigs.length > 0 && <InlineShareChannelsCarousel buttonConfigs={socialConfigs} />}
			</div>
		</div>
	);
};
